import { initVirtualBankList } from './state';
export default {
    RESET_VIRTUAL_BANKS_BY_STORE(state) {
        state.virtualBankList = initVirtualBankList();
    },
    RESET_STORE_DETAIL(state) {
        state.storeDetail = null;
    },
    GET_STORE_VIRTUAL_BANK_LIST(state, payload) {
        state.virtualBankList = payload;
    },
    GET_STORE_DETAIL(state, payload) {
        state.storeDetail = payload;
    },
};
